import { Component, Input, SimpleChanges } from '@angular/core';
import { OAService } from '../../../services/oa.service';
import { NgIf, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';

@Component({
    selector: 'app-oa-removed',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass],
    templateUrl: './oa-removed.component.html',
    styleUrl: './oa-removed.component.scss'
})
export class OaRemovedComponent {
  @Input() setOAData: any;
  loading: boolean = false;
 removedData: any[] = [];
 removedFilterData : any[] = [];
  dropDownData: any[] = [];
  selectedDivision: any = '';

  constructor(private oaService: OAService,private router: Router){
  
    }
  
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['setOAData']) {
        if (this.setOAData) {
          this.processLEData();
        }
      }
    }
  
    processLEData(){
      this.removedData = this.setOAData.tblOAAll_Removed;
      this.removedData.map((item: any) => {
        if (item.tlr_status === 'I') {
          item.status = 'Installed';
          item.cssClass = 'green'
        } else if (item.tlr_status === 'P') {
          item.status = 'Pre Installation';
          item.cssClass = 'blue'
        } else if (item.tlr_status === 'R') {
          item.status = 'Removed';
          item.cssClass = 'red'
        }
      })
    if(this.setOAData.Division_R) {
      this.dropDownData = this.setOAData.Division_R.map((item: any) => {
        return { label: item, value: item };
      });
    }
    this.selectedDivision = this.dropDownData[0].value;
    this.filterRemovedData();
    }
  
    details(row : any){
      this.router.navigate(['/details-section', row.tag_number]);

    }
  
    assignToMe(){
  
    }
    onDivisionChange(event: any){
      this.selectedDivision = event.value;
    }

    filterRemovedData(){
      this.removedFilterData = this.removedData.filter((item: any) => {
        return item.division_name === this.selectedDivision;
      });
    }
      
}
